// `activeCart` may be a hydrating `{}` from saved-cart paths, so require a
// non-nullish `amount` before reading it; otherwise fall through to
// `originalCartTotal`. Number(...) can yield NaN, Infinity, or -Infinity for
// malformed strings — Number.isFinite filters all three to keep the returned
// `number | null` contract honest for callers.

export type PickStoreCartSumInput = {
  originalCartTotal: number | null;
  activeCart?: { amount?: string | number | null } | null;
};

export const pickStoreCartSum = ({
  originalCartTotal,
  activeCart
}: PickStoreCartSumInput): number | null => {
  if (activeCart && activeCart.amount != null) {
    const parsed = Number(activeCart.amount);
    return Number.isFinite(parsed) ? parsed : originalCartTotal;
  }
  return originalCartTotal;
};
